export const release = () => ({
    admin_url: 'https://admin.viafoura.co/admin',
    api_v2_url: 'https://api.viafoura.co/v2',
    console_api_url: 'https://console-api.viafoura.co/v4/console',
    blog_api_url: 'https://usercontent.viafoura.co/v4/liveblog',
    comments_api_url: 'https://livecomments.viafoura.co/v4/livecomments',
    auth_url: 'https://auth.viafoura.co',
    iam_url: 'https://iam.viafoura.co',
    portal_url: 'https://portal.viafoura.co',
    console_url: 'https://console.viafoura.co',
    isProduction: true,
    environment: 'viafoura',
    sentry_dsn: 'https://b3ce730a9bec4252ada8bc632826d3f4@sentry.io/1508275',
    isSentryEnabled: true,
    version_poll_interval: 60 * 1000,
    usernotification_api_url: 'https://notifications.viafoura.co/v5',
});
